import { render } from "./ApiKeyButton.vue?vue&type=template&id=48980b58&scoped=true"
import script from "./ApiKeyButton.vue?vue&type=script&lang=js"
export * from "./ApiKeyButton.vue?vue&type=script&lang=js"

import "./ApiKeyButton.vue?vue&type=style&index=0&id=48980b58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48980b58"]])

export default __exports__